import { Typography } from "@mui/material";
import { Box } from "@mui/system";

interface IProps {
  data: {
    google2fa_code: string;
    google2fa_qrcode: string;
  },
  code?: string;
  setCode: (code: string) => void;
}

export default function ScanQRCode({ data }: IProps) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        margin: "0 auto",
        maxWidth: 500,
        alignItems: "center",
        flexWrap: "wrap",
        minHeight: 200,
      }}
    >
      <img src={data.google2fa_qrcode} alt="qr code" style={{ width: "120px", height: "120px", userSelect: "none" }} />
      <Box sx={{ flex: 1, p: 2, maxWidth: "400px" }}>
        <Typography variant="body2" gutterBottom>
          If you are unable to scan the QR code, please enter this code manually into the app.
        </Typography>
        <Typography variant="subtitle1" gutterBottom sx={{ backgroundColor: "rgb(250, 250, 250)", maxWidth: "200px", textAlign: "center", p: "10px 20px" }}>
          {data.google2fa_code}
        </Typography>
      </Box>
    </Box>
  )
}
